import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { DIVISIONS } from "../../data/content";
import { SectionHeading } from "../common";
import { Reveal } from "../Reveal";

const DivisionCard = ({ d }) => {
    const body = (
        <>
            <div>
                <h3 className="font-display text-xl md:text-2xl font-medium text-white">{d.name}</h3>
                <p className="mt-4 text-sm leading-relaxed text-thg-secondary">{d.text}</p>
            </div>
            <span className="mt-8 inline-flex items-center gap-2 text-xs tracking-[0.15em] uppercase text-thg-tertiary group-hover:text-white transition-colors duration-300">
                Learn more
                <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </span>
        </>
    );
    const cls =
        "group flex flex-col justify-between h-full p-8 md:p-10 hover:bg-thg-surface transition-colors duration-300";
    return d.external ? (
        <a
            href={d.to}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={d.testId}
            className={cls}
            aria-label={`${d.name} — opens dedicated site in a new tab`}
        >
            {body}
        </a>
    ) : (
        <Link to={d.to} data-testid={d.testId} className={cls}>
            {body}
        </Link>
    );
};

export const OperatingAreas = () => (
    <section className="py-24 md:py-32 border-b border-thg-border" data-testid="operating-areas-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <SectionHeading
                index="05"
                overline="Operating Areas"
                title="One group. Six operating lanes."
            />
            <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-thg-border">
                {DIVISIONS.map((d, i) => (
                    <Reveal key={d.name} delay={i * 0.06} className="border-b border-r border-thg-border">
                        <DivisionCard d={d} />
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
